import { Link, useNavigate } from 'react-router-dom';
import { signOut } from '../lib/auth';
import { useAuth } from '../hooks/useAuth';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import LogoMark from './LogoMark';

export default function TopBar() {
  const { user, profile } = useAuth();
  const online = useOnlineStatus();
  const nav = useNavigate();

  return (
    <header className="bg-ink-900 text-white border-b-2 border-brand-500">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 font-bold">
          <LogoMark className="h-8 w-auto" />
          <span className="hidden md:inline text-base">Binary One Solutions</span>
          <span className="md:hidden text-base">B1S CRM</span>
        </Link>
        <nav className="hidden md:flex items-center gap-1 text-sm">
          <NavLink to="/">Sales Hub</NavLink>
          <NavLink to="/pipeline">Pipeline</NavLink>
          <NavLink to="/import/apollo">Import</NavLink>
          <NavLink to="/dashboard">Dashboard</NavLink>
          <NavLink to="/reports">Reports</NavLink>
          {profile?.role === 'admin' && <NavLink to="/users">Users</NavLink>}
          {profile?.role === 'admin' && <NavLink to="/admin">Admin</NavLink>}
        </nav>
        <div className="flex items-center gap-3 text-sm">
          <span
            title={online ? 'Online — changes sync immediately' : 'Offline — changes are queued and will sync on reconnect'}
            className={`chip ${online ? 'bg-brand-500/25 text-brand-100' : 'bg-amber-500/30 text-amber-100'}`}
          >
            {online ? '● Online' : '○ Offline'}
          </span>
          <Link to="/profile" className="hidden sm:block hover:underline text-slate-200">
            {profile?.displayName || user?.email}
          </Link>
          <button
            onClick={async () => { await signOut(); nav('/login'); }}
            className="btn-ghost text-white hover:bg-ink-700"
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}

function NavLink({ to, children }) {
  return (
    <Link to={to} className="px-3 py-2 rounded hover:bg-ink-700 hover:text-brand-300 text-slate-200">
      {children}
    </Link>
  );
}
